import {Component} from '@angular/core';

@Component({
  selector: 'evicare-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
}
